import { render, staticRenderFns } from "./ConfigWeekendDrwtPopup.vue?vue&type=template&id=58b28ac4&"
import script from "./ConfigWeekendDrwtPopup.vue?vue&type=script&lang=js&"
export * from "./ConfigWeekendDrwtPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports